import { render, staticRenderFns } from "./edit_peijianinfo.vue?vue&type=template&id=55bd6a1b&scoped=true&"
import script from "./edit_peijianinfo.vue?vue&type=script&lang=js&"
export * from "./edit_peijianinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd6a1b",
  null
  
)

export default component.exports